export default __webpack_public_path__ + "static/media/family_car_category.4b9df2ea.png";